// AUTO-GENERATED FILE. Do not edit.
export interface BuildInfo {
  version: string;
  build: string;
  commit: string;
  branch: string;
  date: string;
  environment: string;
  /** Version lisible pour les utilisateurs, ex: "v2.1.0 #42" */
  displayVersion: string;
  /** Version technique complète, ex: "2.1.0+42.a3f8b2c" */
  fullVersion: string;
}

export const BUILD_INFO: BuildInfo = {
  "version": "2.1.51",
  "build": "169",
  "commit": "22c17be",
  "branch": "staging",
  "date": "2026-10-23T12:43:04.301Z",
  "environment": "staging",
  "displayVersion": "v2.1.51 #169",
  "fullVersion": "2.1.51+169.22c17be"
} as const;
